<template>
  <div class="c-emergencia">
    <div class="c-emergencia__wrapper">
      <md-subheader>Rentas de quinta categoría</md-subheader>

      <!-- remuneracion anterior -->
      <md-field :class="getValidationClass($v.ldata.totalPrevRemunerations)">
        <label>Remuneración anterior</label>
        <span class="md-prefix">S/.</span>
        <md-input name="rem" id="rem" v-model.number="ldata.totalPrevRemunerations" required></md-input>
        <span class="md-error" v-if="!$v.ldata.totalPrevRemunerations.numeric">Campo debe ser numérico</span>
      </md-field>

      <!-- retencion anterior -->
      <md-field class="getValidationClass($v.ldata.totalPrevRetentions)">
        <label>Retención anterior</label>
        <span class="md-prefix">S/.</span>
        <md-input name="ret" id="ret" v-model.number="ldata.totalPrevRetentions" required></md-input>
        <span class="md-error" v-if="!$v.ldata.totalPrevRetentions.numeric">Campo debe ser numérico</span>
      </md-field>

      <md-subheader>En caso de emergencia</md-subheader>
      
      
      <!-- codigo cuspp -->
      <md-field :class="getValidationClass($v.ldata.kinshipType)">
        <label>Vínculo Familiar</label>
        <md-input name="vinculo" id="vinculo" v-model="ldata.kinshipType" required></md-input>
        <span class="md-error" v-if="!$v.ldata.kinshipType.alpha">Campo requiere solo letras</span>
      </md-field>

      <!-- nombres -->
      <md-field :class="getValidationClass($v.ldata.contactFirstName)">
        <label>Nombres</label>
        <md-input name="nombres" id="nombres" v-model="ldata.contactFirstName" required></md-input>
        <span class="md-error" v-if="!$v.ldata.contactFirstName.isAlpha">Campo requiere solo letras</span>
      </md-field>

      <!-- apellido paterno -->
      <md-field :class="getValidationClass($v.ldata.contactFirstSurname)">
        <label>Apellido Paterno</label>
        <md-input name="apPaterno" id="apPaterno" v-model="ldata.contactFirstSurname" required></md-input>
        <span class="md-error" v-if="!$v.ldata.contactFirstSurname.isAlpha">Campo requiere solo letras</span>
      </md-field>

      <!-- apellido materno -->
      <md-field :class="getValidationClass($v.ldata.contactSecondSurname)">
        <label>Apellido Materno</label>
        <md-input name="apMaterno" id="apMaterno" v-model="ldata.contactSecondSurname" required></md-input>
        <span class="md-error" v-if="!$v.ldata.contactSecondSurname.isAlpha">Campo requiere solo letras</span>
      </md-field>

      <!-- numero telefono -->
      <md-field :class="getValidationClass($v.ldata.contactTelephone)">
        <label>Número Teléfono</label>
        <md-input name="numTelf" id="numTelf" v-model="ldata.contactTelephone"></md-input>
        <span class="md-error" v-if="!$v.ldata.contactTelephone.numeric">Campo requiere solo números</span>
      </md-field>

      <!-- numero celular -->
      <md-field :class="getValidationClass($v.ldata.contactCellphone)">
        <label>Número Celular</label>
        <md-input name="numCel" id="numCel" v-model="ldata.contactCellphone" required></md-input>
        <span class="md-error" v-if="!$v.ldata.contactCellphone.isPhone">Números de celular incorrecto</span>
      </md-field>
    </div>

    <md-button
      v-if="ldata.state!='registered'"
      class="md-raised c-emergencia__sgte"
      @click="finalize()">Registrar Empleado</md-button>

    <md-button v-else
      class="md-raised c-emergencia__sgte"
      >Actualizar Empleado</md-button>

  </div>
</template>

<script>
import { mapActions } from 'vuex'

import EventBus from '@/eventBus'

import {
  alpha,
  numeric,
  helpers
  } from "vuelidate/lib/validators";

const isPhone = helpers.regex('numeric', /^9[0-9]{8}$/)
const isAlpha = helpers.regex('alpha', /^[a-zA-ZÀ-ÿñÑ ]*$/)


export default {
  props: {
    value: Object
  },
  created(){
    if(this.value.id)
      this.ldata = this.value
    if(!this.ldata.totalPrevRemunerations)
      this.$set(this.ldata, 'totalPrevRemunerations', 0)
      // this.ldata.totalPrevRemunerations = 0
    if(!this.ldata.totalPrevRetentions)
      this.$set(this.ldata, 'totalPrevRetentions', 0)
      // this.ldata.totalPrevRetentions = 0

  },
  data() {
    return {
      ldata: {},
      vinculo: null,
      nombres: null,
      apPaterno: null,
      apMaterno: null,
      numTelf: null,
      numCel: null,
    };
  },
  validations: {
    vinculo: { alpha },
    nombres: { alpha },
    apPaterno: { alpha },
    apMaterno: { alpha },
    numTelf: { numeric },
    numCel: { numeric },
    ldata: {
      totalPrevRemunerations: { numeric },
      totalPrevRetentions: { numeric },
      kinshipType: { alpha },
      contactFirstName: { isAlpha },
      contactFirstSurname: { isAlpha },
      contactSecondSurname: { isAlpha },
      contactTelephone: {numeric},
      contactCellphone: {isPhone}
    }
  },

  watch: {
    value(newValue,oldValue){
      this.ldata = newValue
    }
  },

  methods: {
    ...mapActions({
      updateTRegister: 'updateTRegister',
      getTRegisters: 'getTRegisters'
    }),

    getValidationClass(validation) {
      if (validation.$model === null) {
        return {
          "md-invalid": validation.$invalid && validation.$dirty
        };
      } else {
        validation.$touch();
        return {
          "md-invalid": validation.$invalid && validation.$dirty
        };
      }
    },

    dataPrincipal(){
      return this.ldata.documentType &&
              this.ldata.documentNumber &&
              this.ldata.firstName &&
              this.ldata.firstSurname &&
              this.ldata.secondSurname &&
              this.ldata.bornDate &&
              this.ldata.phone &&
              this.ldata.email
    },

    dataAddress(){

      let obj = this.ldata.address
      let nroSlot = 0
      for(let prop in obj)
        if(obj[prop]!="")
          nroSlot++

      return this.ldata.country &&
              this.ldata.department &&
              this.ldata.province &&
              this.ldata.district &&
              nroSlot>=5
    },

    dataLaboral(){
      let payment = false
      if(this.ldata.paymentType=='2'&&
          this.ldata.bankAccount)
          payment = true
      if(this.ldata.paymentType=='1'){
        this.ldata.bankAccount = ""
        payment = true
      }
      
      return this.ldata.admittedAt &&
              this.ldata.laborRegime &&
              this.ldata.contractType &&
              this.ldata.workerType &&
              this.ldata.workdayType &&
              this.ldata.occupation &&
              this.ldata.paymentType &&
              this.ldata.periodicityPayment &&
              this.ldata.grossSalary && payment
    },

    dataSeguridadSocial(){
      let regSalud = false
      if(this.ldata.healthRegime=='01'&&this.ldata.eps)
        regSalud = true
      if(this.ldata.healthRegime!='01')
        regSalud = true
      
      let regPen = false
      if(this.ldata.pensionSystem!='02'&&this.ldata.cuspCode&&this.ldata.pensionSystemType)
        regPen = true
      if(this.ldata.pensionSystem=='02')
        regPen = true

      return this.ldata.healthRegime &&
              this.ldata.pensionSystem &&
              regSalud && regPen
    },

    dataEmergencia(){
      console.log(this.ldata.totalPrevRetentions, this.ldata.totalPrevRemunerations);
      
      return this.ldata.kinshipType &&
              this.ldata.contactFirstName &&
              this.ldata.contactFirstSurname &&
              this.ldata.contactSecondSurname &&
              this.ldata.contactCellphone && true
              // this.ldata.totalPrevRetentions &&
              // this.ldata.totalPrevRemunerations
    },

    finalize() {
      let stateLocal = ""
      EventBus.$on(val => {
        stateLocal = val
      })
      console.log("data principal: ",this.dataPrincipal())
      console.log("data address: ",this.dataAddress())
      console.log("data laboral: ",this.dataLaboral())
      console.log("data seg social: ",this.dataSeguridadSocial())
      console.log("data emergen: ",this.dataEmergencia())

      if(this.dataPrincipal()&&this.dataAddress()&&
          this.dataLaboral()&&this.dataSeguridadSocial()&&
          this.dataEmergencia()){
            this.ldata.isComplete = true
            this.updateTRegister(this.ldata)
          }
      else{
        console.log("estado pendiente")
        this.ldata.isComplete = false
        this.updateTRegister(this.ldata)
      }
      // this.getTRegisters(this.$localStorage.get('businessID'))
      this.getTRegisters({
        id: this.$localStorage.get('businessID'),
        state: stateLocal,
        page: 1
      }).then(r => {
        if(r.status==200){
          EventBus.$emit('pageDefault')
          EventBus.$emit('totalPages',r.data.totalPages)
        }
      })
      this.$emit('closeModal')

    }
  }
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS

//vue-material
.md-field {
  width: 15rem;
  margin: 0 3rem 2rem 3rem;

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.md-checkbox{
  width: 15rem;
  margin: 0 3rem 2rem 3rem;
  display: flex;
  align-items: center;
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}


.md-subheader{
  width: 100%;
  color: $b-blue-dark !important;
}

.c-emergencia {
  background-color: white;
  padding: 1rem 1rem 3rem 1rem;
  margin: 0 auto;
  position: relative;
  @include mq($sm) {
    padding: 1rem 3rem 3rem 3rem;
  }
  @include mq($md) {
    width: 90%;
    border-radius: 6px;
  }
  &__wrapper {
    position: relative;
    @include mq($md) {
      display: flex;
      flex-wrap: wrap;
      // justify-content: center;
      // margin-top: 6rem;
    }
  }
  &__sgte {
    display: block;
    color: #fff !important;
    background-color: $b-orange !important;
    margin: 5rem auto !important;
  }
}
</style>

